/* ab-sticky-bestelknop.js — sticky bestelknop op de productpagina (Arctic Blue, mobiel + desktop)
   Winnaar van A/B-test #10 "Sticky bestelknop" (Intelligems 5cc94fd5, sep–okt 2026: CR +14 %,
   RPV +21 %), 1:1 native gemaakt; de bijbehorende CSS staat in ab-sticky-bestelknop.css en het
   rendert alleen via snippets/ab-sticky-bestelknop.liquid (NL-PDP's, niet ?view=advertorial).

   Balk onderaan het scherm zodra de originele bestelknop (.buy-buttons-block) uit beeld is
   gescrold: thumbnail (og:image) + productnaam/prijs links, kleine aan/uit-switch "Abonnement"
   ernaast, de knop rechts.

   De switch spiegelt de eenmalig/abonnement-radio's van het keuzeblok (.ab-so,
   blocks/ab-subscription-options): omzetten klikt de echte radio aan, dus het keuzeblok zelf
   regelt selling plan, knoptekst en prijzen. Eenmalig = standaard: zodra de balk voor het eerst
   in beeld komt en er nog niks gekozen is, kiest hij eenmalig (de poort verdwijnt dan ook in het
   keuzeblok). Geen keuzeblok = geen switch.

   De knop in de balk is een spiegel van de echte knop: dezelfde tekst ("In winkelmand",
   "Ja, ik sluit abonnement af", "Kies eenmalig of abonnement", "Uitverkocht") en dezelfde
   disabled-staat. Klikken = de echte knop klikken, dus het theme doet het toevoegen zelf
   (juiste variant, aantal, selling plan). Staat de echte knop nog op de eenmalig/abonnement-
   poort (data-ab-gated), dan scrolt de balk naar die keuze in plaats van niets te doen.
   De prijs volgt de keuze: eenmalig = .ab-so__price, abonnement = de gekozen frequentie-tegel.

   Maakt ruimte voor zichzelf: de Klaviyo-teaser "10% korting?" wordt een verticaal tabje aan de
   rechterrand, de HelpCrunch-chatknop schuift mee omhoog boven de balk (html-classes
   ab-sticky-bar-on / ab-sticky-hc-open / ab-sticky-hc-small, zie de CSS).

   Verdwijnt zodra de cart drawer (#cart-drawer-dialog[open]) opent, en komt terug als hij
   sluit. Taal/template worden al in Liquid gefilterd (snippet); de checks hieronder op pad,
   /products/ en ?view=advertorial blijven als vangnet staan. */
(function () {
  if (window.__abStickyBestelknop) return;
  window.__abStickyBestelknop = true;
  if (/^\/(en|de|fr)(\/|$)/.test(location.pathname)) return;
  if (location.pathname.indexOf('/products/') === -1) return;
  if (/[?&]view=advertorial(&|$)/.test(location.search)) return;

  var ID = 'ab-sticky-bar';
  var bar = null, raf = null, ioBuy = null, obsDom = null, obsDialog = null, watchedDialog = null;
  var buyOut = false;      // originele bestelknop uit beeld (boven de viewport)
  var loading = false, loadTimer = null, lastH = 0, defaulted = false;

  function q(s, r) { return (r || document).querySelector(s); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function realBtn() {
    var pi = q('.product-information') || document;
    return q('.product-form-buttons .add-to-cart-button', pi) || q('form.shopify-product-form .add-to-cart-button', pi);
  }
  function buyBlock() { var b = realBtn(); return b ? (b.closest('.buy-buttons-block') || b.closest('.product-form-buttons') || b) : null; }
  function dialog() { return q('#cart-drawer-dialog'); }

  function priceInfo() {
    var so = q('.ab-so');
    if (so) {
      var purchase = q('input[name^="ab-purchase-"]:checked', so);
      if (purchase && purchase.value === 'subscribe') {
        var tile = q('input[name^="ab-frequency-"]:checked', so);
        var wrap = tile && tile.closest('.ab-so__tile');
        var cur = wrap && q('.ab-so__tile-current', wrap);
        if (cur) {
          var sub = txt(wrap && q('.ab-so__tile-sub', wrap));           // "3 flesjes voor 3 maanden"
          var m = sub.match(/^\d+\s+\S+/);
          return { main: txt(cur), sub: m ? m[0] : sub };
        }
      } else {
        var bundle = q('input[name^="ab-bundle-"]:checked', so);
        var bw = bundle && bundle.closest('.ab-so__bundle');
        var strong = bw && q('.ab-so__bundle-amounts strong', bw);
        var qty = bundle && bundle.dataset.qty;
        if (strong && qty && qty !== '1') return { main: txt(strong), sub: 'per flesje · ' + qty + ' flesjes' };
        var p = q('.ab-so__price', so);
        if (p) return { main: txt(p), sub: '' };
      }
    }
    var pe = q('.product-price-block .price') || q('.price-container .price') || q('.price');
    return { main: txt(pe), sub: '' };
  }

  function build() {
    var el = document.createElement('div');
    el.id = ID;
    el.className = 'ab-sticky';
    el.innerHTML =
      '<img class="ab-sticky__thumb" alt="" width="48" height="48">' +
      '<div class="ab-sticky__info"><div class="ab-sticky__title"></div><div class="ab-sticky__price"></div></div>' +
      '<button type="button" class="ab-sticky__toggle" role="switch" aria-checked="false" aria-label="Abonnement"><span class="ab-sticky__knob"></span><span class="ab-sticky__tlabel">Abonnement<span class="ab-sticky__tsub"></span></span></button>' +
      '<button type="button" class="ab-sticky__btn"><span class="ab-sticky__txt"></span>' +
      '<svg class="ab-sticky__icon" viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 6h12l-1 10H5L4 6z"/><path d="M7 6a3 3 0 0 1 6 0"/></svg>' +
      '<span class="ab-sticky__spin" aria-hidden="true"></span></button>';
    q('.ab-sticky__btn', el).addEventListener('click', onClick);
    q('.ab-sticky__toggle', el).addEventListener('click', onToggle);
    var thumb = thumbSrc();
    if (thumb) q('.ab-sticky__thumb', el).src = thumb;
    return el;
  }

  function thumbSrc() {
    var og = q('meta[property="og:image"]');
    var src = og && og.content;
    if (!src) { var im = q('.product-media img, media-gallery img, .media-gallery img'); src = im && (im.currentSrc || im.src); }
    if (!src) return '';
    src = src.replace(/^http:\/\//, 'https://'); // og:image staat op http://, geen mixed content
    if (/cdn\/shop\//.test(src) && !/[?&]width=/.test(src)) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    return src;
  }

  // Switch: de echte radio in het keuzeblok aanklikken; het blok doet de rest (change bubbelt, sync volgt).
  function purchaseInput(val) { return q('.ab-so input[name^="ab-purchase-"][value="' + val + '"]'); }
  function onToggle(ev) {
    ev.preventDefault();
    var sub = purchaseInput('subscribe'), one = purchaseInput('onetime');
    if (!sub || !one) return;
    if (sub.checked) one.click(); else sub.click();
    schedule();
  }

  function onClick(ev) {
    ev.preventDefault();
    var b = realBtn();
    if (!b) return;
    if (b.disabled) {
      if (b.dataset.abGated) {
        // hoort niet voor te komen (eenmalig wordt standaard gekozen zodra de balk verschijnt); vangnet: kies alsnog eenmalig
        var one = purchaseInput('onetime');
        if (one && !one.checked) { one.click(); schedule(); return; }
        var so = q('.ab-so');
        if (so) { try { so.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { so.scrollIntoView(); } }
      }
      return;
    }
    setLoading(true);
    b.click();
  }
  function setLoading(on) {
    loading = on;
    if (bar) bar.classList.toggle('is-loading', on);
    if (loadTimer) { clearTimeout(loadTimer); loadTimer = null; }
    if (on) loadTimer = setTimeout(function () { setLoading(false); }, 8000);
  }

  function sync() {
    if (!bar) return;
    var b = realBtn();
    var t = q('.ab-sticky__title', bar), p = q('.ab-sticky__price', bar), bt = q('.ab-sticky__btn', bar), tx = q('.ab-sticky__txt', bar);
    var h1 = q('.product-information h1') || q('h1');
    var title = txt(h1);
    if (t.textContent !== title) t.textContent = title;
    var pi = priceInfo();
    var ptxt = pi.main + (pi.sub ? ' · ' + pi.sub : '');
    if (p.textContent !== ptxt) p.textContent = ptxt;
    var gated = !!(b && b.disabled && b.dataset.abGated);
    // Poort actief (nog geen keuze eenmalig/abonnement): de balk zegt gewoon "In winkelmand",
    // een klik scrolt naar de keuze. De lange poorttekst past niet naast de productnaam.
    var label = gated ? (b.dataset.addToCartText || 'In winkelmand') : (b ? (txt(q('.add-to-cart-text__content', b)) || txt(b)) : 'In winkelmand');
    if (tx.textContent !== label) tx.textContent = label;
    bar.classList.toggle('is-long', label.length > 16);
    var dis = !!(b && b.disabled && !gated);
    bt.disabled = dis;
    bar.classList.toggle('is-gated', gated);
    // switch: stand + kortingstekst live uit het keuzeblok
    var subIn = purchaseInput('subscribe'), oneIn = purchaseInput('onetime');
    bar.classList.toggle('no-switch', !(subIn && oneIn));
    if (subIn && oneIn) {
      var tg = q('.ab-sticky__toggle', bar), so = q('.ab-so');
      var subS = txt(so && q('.ab-so__discount', so)), sEl = q('.ab-sticky__tsub', tg);
      if (sEl.textContent !== subS) sEl.textContent = subS;
      tg.setAttribute('aria-checked', subIn.checked ? 'true' : 'false');
    }
    var d = dialog();
    var open = !!(d && d.hasAttribute('open'));
    var show = buyOut && !open && !!b;
    // eenmalig als standaard: de eerste keer dat de balk in beeld komt en er nog niks gekozen is
    if (show && !defaulted && gated && oneIn && subIn && !oneIn.checked && !subIn.checked) {
      defaulted = true; oneIn.click(); schedule(); return;
    }
    bar.classList.toggle('is-on', show);
    document.documentElement.classList.toggle('ab-sticky-bar-on', show);
    var h = bar.offsetHeight;
    if (h && h !== lastH) { lastH = h; document.documentElement.style.setProperty('--ab-sticky-h', h + 'px'); }
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; sync(); }); }

  function measure() {
    var bb = buyBlock();
    if (!bb) { buyOut = false; return; }
    var r = bb.getBoundingClientRect();
    buyOut = r.bottom < 0;
  }

  function watchBuy() {
    var bb = buyBlock();
    if (!bb || ioBuy) return;
    if ('IntersectionObserver' in window) {
      ioBuy = new IntersectionObserver(function () { measure(); schedule(); }, { threshold: [0, 1] });
      ioBuy.observe(bb);
    }
    window.addEventListener('scroll', function () { measure(); schedule(); }, { passive: true });
    window.addEventListener('resize', function () { measure(); schedule(); });
    measure(); schedule();
  }

  function watchDialog() {
    var d = dialog();
    if (!d || d === watchedDialog) return;
    watchedDialog = d;
    if (obsDialog) obsDialog.disconnect();
    obsDialog = new MutationObserver(schedule);
    obsDialog.observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  // HelpCrunch: chat open (fullscreen, iframe-breedte in %) -> class ab-sticky-hc-open = geen override;
  // alleen de ronde knop (<= 80px) -> class ab-sticky-hc-small = iets verkleinen. Events van de
  // HelpCrunch-API als eerste bron, het inline style-attribuut van het iframe als vangnet.
  var hcFrame = null, hcObs = null, hcOpen = false, hcTries = 0;
  function hcSync() {
    var f = hcFrame || q('.helpcrunch-iframe-wrapper iframe');
    var w = f ? (f.style.width || '') : '';
    var pct = /%/.test(w) || /%/.test(f ? (f.style.height || '') : '');
    var px = parseFloat(w) || 0;
    var open = hcOpen || pct || (px && window.innerWidth && px >= window.innerWidth - 2);
    document.documentElement.classList.toggle('ab-sticky-hc-open', !!open);
    document.documentElement.classList.toggle('ab-sticky-hc-small', !open && (!f || !px || px <= 80));
  }
  function watchHc() {
    var f = q('.helpcrunch-iframe-wrapper iframe');
    if (f && f !== hcFrame) {
      hcFrame = f;
      if (hcObs) hcObs.disconnect();
      hcObs = new MutationObserver(hcSync);
      hcObs.observe(f, { attributes: true, attributeFilter: ['style'] });
      hcSync();
    }
    if (hcTries >= 0 && typeof window.HelpCrunch === 'function') {
      hcTries = -1;
      try {
        window.HelpCrunch('onChatOpen', function () { hcOpen = true; hcSync(); });
        window.HelpCrunch('onChatClose', function () { hcOpen = false; hcSync(); });
      } catch (e) {}
    } else if (hcTries >= 0 && hcTries < 120) { hcTries++; setTimeout(watchHc, 500); }
  }

  function mount() {
    if (!document.body) return false;
    if (!realBtn()) return false;
    if (!bar) {
      bar = q('#' + ID) || build();
      if (!bar.isConnected) document.body.appendChild(bar);
      document.documentElement.classList.add('ab-sticky-on');
      document.addEventListener('change', schedule, true);
      document.addEventListener('cart:update', function () { setLoading(false); schedule(); });
      document.addEventListener('cart:error', function () { setLoading(false); schedule(); });
      document.addEventListener('cart:add', function () { setLoading(false); schedule(); });
    }
    watchBuy();
    watchDialog();
    watchHc();
    sync();
    return true;
  }

  // Het script laadt met defer vanuit <head>; de buy box en de cart drawer kunnen later (her)renderen
  // (variantwissel, section-morph), dus blijven kijken via een MutationObserver.
  function arm() {
    mount();
    if (!document.documentElement) { setTimeout(arm, 30); return; }
    if (!obsDom) {
      obsDom = new MutationObserver(function () { mount(); schedule(); });
      obsDom.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'checked', 'hidden', 'class'] });
    }
  }
  arm();
  document.addEventListener('DOMContentLoaded', arm);
  window.addEventListener('load', arm);
})();
